import { filterValuesTypes } from 'consts'
import Store from 'redux/Store'
import { setMessage } from 'redux/actions'

interface prepareSubmitFormProps {
  submitForm: Function
  setButtonClickCount: Function
  reset: Function
  data: any
  id: string
  setShowOverlay: Function
  setValue: Function
  name: string
  setError?: Function
}

const prepareSubmitForm = async (props: prepareSubmitFormProps) => {
  props
    .submitForm({
      id: props.id,
      data: props.data,
      setError: props?.setError,
      setShowOverlay: props.setShowOverlay,
    })
    .then((response: any) => {
      if(response.status === 200 || response.status === 201){
        Store.dispatch(setMessage(props.name + ' successfully saved.', 'success', 'instant', false))
        props.setButtonClickCount((prev) => prev + 1)
        props.reset()
        props.setValue('type', filterValuesTypes[0])
        props.setShowOverlay(false)
      } 
    })

  return true
}

export default prepareSubmitForm
